// extracted by mini-css-extract-plugin
export default {"root":"ImageUser_root__rUcYC","large":"ImageUser_large__B-xsI","image":"ImageUser_image__T-LHr"};